/**
 * Utility for constructing sized arche icon URLs.
 *
 * Icons are stored in S3 at multiple sizes:
 *   {archId}/icon.png      — 1024px original
 *   {archId}/icon-512.png  — 512px
 *   {archId}/icon-256.png  — 256px
 *   {archId}/icon-128.png  — 128px
 *   {archId}/icon-64.png   — 64px
 */

export type IconSize = 64 | 128 | 256 | 512;

/**
 * Derive a sized icon URL from the original image_ref.
 * Returns the original URL if no size is specified or the URL doesn't match the expected pattern.
 */
export function archeIconUrl(imageRef: string | null | undefined, size?: IconSize): string | null {
  if (!imageRef) return null;
  if (!size) return imageRef;
  const replaced = imageRef.replace(/\/icon\.(\w+)$/, `/icon-${size}.$1`);
  // If the replacement didn't change anything, the URL doesn't match our pattern — return original
  return replaced === imageRef ? imageRef : replaced;
}
